import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RelType } from '@inshared/website-ui-components';
import { AppRoutesEnum, ExternalRoutesEnum, PhoneNumbersEnum } from '@inshared/shared/core';
import { NativeRouterService } from '@inshared/shared/util';

@Component({
    selector: 'ins-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
    @Input() public useAngularRouter: boolean = false;

    public appRoutesEnum = AppRoutesEnum;
    public externalRoutesEnum = ExternalRoutesEnum;
    public phoneNumbersEnum = PhoneNumbersEnum;
    public nativeRouterService = inject(NativeRouterService);
    public baseUrl = this.nativeRouterService.baseUrl;
    // 'noopener noindex nofollow' results in type error
    public rel: RelType = 'noopener noindex nofollow' as unknown as RelType;

    constructor(private router: Router) {}

    public generateRoute(route: string): string {
        return this.useAngularRouter ? route : '';
    }

    public generateUrl(route: string, fragment?: string): string {
        return this.useAngularRouter ? '' : `${this.baseUrl}/${route}${fragment ? `#${fragment}`: ''}`;
    }

    public navigateToRoute(route: string): void {
        if (this.useAngularRouter) {
            this.router.navigate([route]);
            return;
        }

        this.nativeRouterService.navigateByUrl(`${this.baseUrl}/${route}`);
    }
}
